module.exports = __webpack_public_path__ + "media/focus_skill/focus_skill_star_gray-ce5991c9.svg";